import { Reveal } from "./Reveal";
import { EXPERIENCE } from "../lib/data";

export const Experience = () => {
  return (
    <section id="experience" className="py-24 lg:py-36" data-testid="experience-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <Reveal>
          <p className="text-xs font-semibold uppercase tracking-[0.25em] text-brand mb-6">Experience</p>
          <h2 className="font-display font-bold text-4xl sm:text-5xl lg:text-6xl tracking-tight text-ink max-w-3xl">
            15+ years of <span className="text-gradient">designing & building.</span>
          </h2>
        </Reveal>

        <div className="mt-16 space-y-5">
          {EXPERIENCE.map((e, i) => (
            <Reveal key={e.company} delay={i * 0.05}>
              <div className="group glass rounded-3xl p-8 hover:-translate-y-1 transition-transform duration-300 grid lg:grid-cols-12 gap-6" data-testid={`experience-item-${i}`}>
                <div className="lg:col-span-4">
                  <h3 className="font-display font-semibold text-xl lg:text-2xl text-ink">{e.company}</h3>
                  <p className="text-sm text-brand mt-1 font-semibold">{e.role}</p>
                </div>
                <ul className="lg:col-span-8 grid sm:grid-cols-2 gap-x-8 gap-y-3">
                  {e.points.map((pt) => (
                    <li key={pt} className="flex items-start gap-3 text-ink-soft font-light text-[15px] leading-relaxed">
                      <span className="mt-2 w-1.5 h-1.5 rounded-full btn-gradient flex-shrink-0" />
                      {pt}
                    </li>
                  ))}
                </ul>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
